module.exports = __webpack_public_path__ + "images/emoji/neutral_face.1946287de97cb01b203d.png";